import { Expose, Transform, Type } from "class-transformer";
import { CrmCompanyDto } from "./crm-company.dto";
import { CrmContactDto } from "./crm-contact.dto";
import { CrmCustomerDto } from "./crm-customer.dto";

export class CrmEntryDto {
  @Type(() => CrmContactDto)
  @Expose()
  contact?: CrmContactDto;

  @Type(() => CrmCompanyDto)
  @Expose()
  company?: CrmCompanyDto;

  @Type(() => CrmCustomerDto)
  @Expose()
  @Transform(({ value, obj }) => value ?? obj["customer_shippedTo"])
  customerShippedTo?: CrmCustomerDto;

  @Type(() => CrmCustomerDto)
  @Expose()
  @Transform(({ value, obj }) => value ?? obj["customer_soldTo"])
  customerSoldTo?: CrmCustomerDto;

  @Type(() => CrmCustomerDto)
  @Expose()
  endUser?: CrmCustomerDto;

  @Expose()
  name?: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["opportunityid"])
  opportunityId?: string;

  @Expose()
  opportunityLink?: string;
}
